const modelAltText = (modelName) => {
  if (!modelName || typeof modelName !== 'string') {
    return 'An image of a model'
  }

  // Just in case there's any casing that has been messed with we want to
  // capitalize the first letter of each word

  const capitalizedModelName = modelName
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')

  return `An image of ${capitalizedModelName}`
}

export default modelAltText
